import { useRef, useState } from 'react'
import { useProcessMonitor } from '../model/useProcessMonitor'
import { ProcessMonitorButton } from './ProcessMonitorButton'
import { ProcessMonitorModal } from './ProcessMonitorModal'

/**
 * Монитор процессов 1С в хвосте меню: кнопка со статусом и числом процессов и модалка очереди
 * со всеми подробностями, включая связь с 1С. Один запрос на всё — `useProcessMonitor`.
 * Фокус после закрытия модалки возвращается на кнопку: её же и нажимали.
 */
export function ProcessMonitor() {
  const { data, isLoading, isError, error, refetch } = useProcessMonitor()
  const [open, setOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const close = () => {
    setOpen(false)
    buttonRef.current?.focus()
  }

  return (
    <>
      <ProcessMonitorButton
        ref={buttonRef}
        data={data}
        isLoading={isLoading}
        isError={isError}
        onOpen={() => setOpen(true)}
      />

      <ProcessMonitorModal
        open={open}
        onClose={close}
        data={data}
        isLoading={isLoading}
        isError={isError}
        error={error}
        onRetry={() => void refetch()}
      />
    </>
  )
}
